var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"equipe"}},[_c('Header'),_c('Banner'),_c('Neuronios'),_c('TrabalheConosco')],1)}
var staticRenderFns = []

export { render, staticRenderFns }